<template>
  <v-container
    id="order-success-page"
    class="fill-height flex-column justify-center mt-4 mt-lg-0">
    <div class="primary--text font-weight-bold _fs-36">
      {{ title }}
    </div>
    <div class="mt-4 d-flex align-center flex-wrap">
      <div class="_fs-24 mr-4">
        เลขที่ใบสั่งซื้อ :
      </div>
      <router-link
        :to="{ name: 'OrderDetail', params: { id: orderResult._id } }"
        class="font-weight-bold _fs-36 info--text"
      >
        {{ orderResult.code }}
      </router-link>
    </div>
    <div class="mt-4 text-center _fs-20 error--text">
      คุณสามารถดูรายละเอียดใบเสนอราคาได้ที่รายการสั่งซื้อ,<br>
      Bot OA by Sellsuki, และ Email ที่ระบุไว้ในระบบ<br>
      คุณสามารถแจ้งชำระเงินได้ตามช่องทางดังนี้
    </div>

    <base-payment-method-card
      :order-id="orderResult._id"
      class="mt-8"
    />

    <v-btn
      class="my-8"
      color="primary"
      rounded
      outlined
      min-width="200"
      exact
      :to="{ name: 'Home' }"
    >
      กลับสู่หน้าหลัก
    </v-btn>
    <qr-line />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'OrderSuccessPage',
  components: {
    BasePaymentMethodCard: () => import('@/components/Order/BasePaymentMethodCard'),
    qrLine: () => import('@/components/QRLINE.vue')
  },
  computed: {
    ...mapState('Order', ['createOrderResult', 'updateOrderByIdResult']),
    ...mapState('User', ['userProfile']),
    lineUid() {
      return this.userProfile?.uid || null
    },
    ...mapGetters({
      activeLineOfficialAccount: 'User/activeLineOfficialAccount'
    }),
    isEdit() {
      return this.$route.query.isEdit
    },
    title() {
      return this.isEdit ? 'คุณได้ทำการแก้ไขสำเร็จแล้ว' : 'คุณได้ทำรายการสั่งซื้อสำเร็จแล้ว'
    },
    orderResult() {
      return this.isEdit ? this.updateOrderByIdResult : this.createOrderResult
    }
  },
  mounted () {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'order_success',
      category: 'user_action',
      label: 'order_success',
      value: 1,
      userId: this.lineUid,
      premium_id: this.activeLineOfficialAccount.premiumId || null,
      basic_id: this.activeLineOfficialAccount.basicId || null,
      customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new',
      order_code: this.orderResult.code
    })
    if (!this.$store.getters['Order/orderResultCode']) {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
